export const reviewsData = [
  {
    rating: 5,
    name: 'Elliot',
    date: 'January 3, 2024',
    text:
      'The beach bum is such an awesome van! Such a comfortable trip. We had it for 2 weeks and there was not a single issue. Super clean when we picked it up and the host is very comfortable and understanding. Highly recommend!',
    id: '1',
  },
  {
    rating: 5,
    name: 'Sandy',
    date: 'December 12, 2023',
    text:
      'This is our third time using the Modest Explorer for our travels and we love it! No complaints, absolutely perfect!',
    id: '2',
  },
];

export const transactionsData = [
  { amount: 720, date: "Jan 3, '24", id: '1' },
  { amount: 560, date: "Dec 12, '23", id: '2' },
  { amount: 980, date: "Dec 3, '23", id: '3' },
];
